import { render, staticRenderFns } from "./TableCommunicationTemplate.vue?vue&type=template&id=03d22898"
import script from "./TableCommunicationTemplate.vue?vue&type=script&lang=js"
export * from "./TableCommunicationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports